import type { FC, PropsWithChildren } from 'react';

import classNames from 'classnames';
import { observer } from 'mobx-react';

import type { FullPageDialogs } from '../../stores/ui/types';
import { useStores } from '../../stores/useStores';

interface INavigationItemProps extends PropsWithChildren {
  title?: string;
  onClick: (dialog: FullPageDialogs | null) => void;
  dialog: FullPageDialogs | null;
  additionalDialogs?: FullPageDialogs[];
  disabled?: boolean;
}

const NavItem: FC<INavigationItemProps> = observer((props) => {
  const { uiStore } = useStores();

  const { dialog, additionalDialogs, onClick, children, title, disabled } = props;

  const dialogs = additionalDialogs ? [dialog, ...additionalDialogs] : [dialog];

  const onClickHandler = disabled ? undefined : () => onClick(dialog);

  return (
    <div
      className={classNames('nav-item', {
        'nav-item_active': dialogs.includes(uiStore.openFullPageDialog),
        'nav-item_onboarding': true,
      })}
      data-testid={`mobile-navitem-${dialog}`}
      onClick={onClickHandler}
    >
      <div className="nav-item__icon">{children}</div>
      {title ? <span className="nav-item__title">{title}</span> : null}
    </div>
  );
});

export default NavItem;
